import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, Menu, X, ArrowRight, Leaf } from "lucide-react";
import { BrandMark } from "@/components/BrandMark";
import { SOLUTIONS_MENU, WHY_MENU, RESOURCES_MENU, TRIAL_CTA } from "@/data/marketing";
import "./website.css";
import "./site-dark.css";
const PRODUCT_LINKS = [["The connected Job", "/#workflow"], ["Explore the product", "/#explorer"], ["Office + field", "/#why"], ["All features", "/features"]];
const MENUS = [["Product", PRODUCT_LINKS], ["Solutions", SOLUTIONS_MENU], ["Why Fieldlink", WHY_MENU], ["Resources", RESOURCES_MENU]];
const NavLink = ({
  to,
  children,
  onClick
}) => to.startsWith("/#") ? <a href={to} onClick={onClick}>{children}</a> : <Link to={to} onClick={onClick}>{children}</Link>;
function Dropdown({
  label,
  items
}) {
  const [open, setOpen] = useState(false);
  return <div className="web-menu" onBlur={e => {
    if (!e.currentTarget.contains(e.relatedTarget)) setOpen(false);
  }} onKeyDown={e => {
    if (e.key === "Escape") {
      setOpen(false);
      e.currentTarget.querySelector("button").focus();
    }
  }}><button type="button" aria-expanded={open} onClick={() => setOpen(!open)}>{label}<ChevronDown size={14} /></button>{open && <div className="web-menu-panel">{items.map(([text, to]) => <NavLink key={text} to={to} onClick={() => setOpen(false)}>{text}</NavLink>)}</div>}</div>;
}
// Dark cinematic header for all public pages; `classic` keeps the archived light design.
export function MarketingHeader({ classic = false }) {
  const [mobile, setMobile] = useState(false);
  const location = useLocation();
  useEffect(() => {
    if (classic) return;
    document.documentElement.classList.add("fx-dark");
    return () => document.documentElement.classList.remove("fx-dark");
  }, [classic]);
  if (!classic) return <DarkHeader mobile={mobile} setMobile={setMobile} path={location.pathname} />;
  return <header className="web-nav" key={location.pathname}><div className="web-nav-inner"><Link className="web-brand" to="/" aria-label="Fieldlink NZ home" data-testid="nav-logo"><BrandMark variant="mark" size={32} /><span>FIELDLINK<b>NZ</b></span></Link><nav aria-label="Main">{MENUS.slice(0, 3).map(([label, items]) => <Dropdown key={label} label={label} items={items} />)}<Link to="/pricing">Pricing</Link><Dropdown label="Resources" items={RESOURCES_MENU} /></nav><Link className="web-nav-signin" to="/login" data-testid="nav-signin">Sign in</Link><Link className="web-button" to="/register" data-testid="nav-get-started">{TRIAL_CTA}</Link><button className="web-mobile-toggle" type="button" aria-label={mobile ? "Close navigation" : "Open navigation"} aria-expanded={mobile} aria-controls="public-mobile-menu" onClick={() => setMobile(!mobile)}>{mobile ? <X size={20} /> : <Menu size={20} />}</button></div>{mobile && <nav id="public-mobile-menu" className="web-mobile-menu" aria-label="Mobile" onKeyDown={e => {
      if (e.key === "Escape") {
        setMobile(false);
        e.currentTarget.parentElement.querySelector(".web-mobile-toggle").focus();
      }
    }}>{MENUS.map(([label, items]) => <details key={label}><summary>{label}</summary>{items.map(([text, to]) => <NavLink key={text} to={to} onClick={() => setMobile(false)}>{text}</NavLink>)}</details>)}<Link to="/pricing" onClick={() => setMobile(false)}>Pricing</Link><Link to="/login" onClick={() => setMobile(false)}>Sign in</Link><Link to="/register" onClick={() => setMobile(false)}>{TRIAL_CTA}</Link></nav>}</header>;
}

function DarkHeader({ mobile, setMobile, path }) {
  const close = () => setMobile(false);
  return (
    <header className="fxh" key={path} data-testid="site-header">
      <div className="fxh-inner">
        <Link className="fxh-brand" to="/" aria-label="Fieldlink NZ home" data-testid="nav-logo"><img src="/brand/fieldlink-mark.png" alt="" /><span>Fieldlink</span></Link>
        <nav className="fxh-nav" aria-label="Main">
          {MENUS.slice(0, 3).map(([label, items]) => <Dropdown key={label} label={label} items={items} />)}
          <Link to="/pricing">Pricing</Link>
          <Dropdown label="Resources" items={RESOURCES_MENU} />
        </nav>
        <div className="fxh-right">
          <span className="fxh-nz"><Leaf size={18} aria-hidden="true" /><span>100% NZ Owned<br />&amp; Supported</span></span>
          <Link className="fxh-login" to="/login" data-testid="nav-signin">Log in</Link>
          <Link className="fxh-cta" to="/register" data-testid="nav-get-started">Start free trial <ArrowRight size={16} /></Link>
          <button className="fxh-toggle" type="button" aria-label={mobile ? "Close navigation" : "Open navigation"} aria-expanded={mobile} aria-controls="public-mobile-menu" onClick={() => setMobile(!mobile)} data-testid="nav-mobile-toggle">{mobile ? <X size={20} /> : <Menu size={20} />}</button>
        </div>
      </div>
      {mobile && (
        <nav id="public-mobile-menu" className="fxh-mobile" aria-label="Mobile" onKeyDown={(e) => { if (e.key === "Escape") { close(); e.currentTarget.parentElement.querySelector(".fxh-toggle").focus(); } }}>
          {MENUS.map(([label, items]) => <details key={label}><summary>{label}</summary>{items.map(([text, to]) => <NavLink key={text} to={to} onClick={close}>{text}</NavLink>)}</details>)}
          <Link to="/pricing" onClick={close}>Pricing</Link>
          <Link to="/login" onClick={close}>Log in</Link>
          <Link className="fxh-cta" to="/register" onClick={close}>{TRIAL_CTA} <ArrowRight size={16} /></Link>
        </nav>
      )}
    </header>
  );
}
